(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-formula"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var sections = document.querySelectorAll('.why-choose-formula');
  if (!sections.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (root) {
    var revealTargets = root.querySelectorAll('[data-wcf-reveal]');

    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealTargets.forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      revealTargets.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    var faqItems = root.querySelectorAll('[data-wcf-faq-trigger]');

    function closeItem(trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', 'false');
      trigger.closest('.why-choose-formula__faq-item').classList.remove('is-open');
      if (panel) panel.style.maxHeight = null;
    }

    function openItem(trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', 'true');
      trigger.closest('.why-choose-formula__faq-item').classList.add('is-open');
      if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    faqItems.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        faqItems.forEach(function (otherTrigger) {
          if (otherTrigger !== trigger) closeItem(otherTrigger);
        });

        if (isOpen) {
          closeItem(trigger);
        } else {
          openItem(trigger);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
